import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { BasePermissionCapability } from "app/based/baseApiModel/basePermissionMenu/BasePermissionCapability";
import { BaseUserResponseModel } from "app/based/baseApiModel/baseUserModel/BaseUserResponseModel";
import { DataFormat } from "utils/format/DataFormat";

export class PermissionDataDetailEntity {
  createdAt?: string;
  updatedAt?: string;
  name?: string;
  code?: string;
  description?: string;
  note?: string;
  type?: number;
  status?: number;
  order?: string;
  displayName?: string;
  componentName?: string;
  path?: string;
  icon?: string;
  key?: string;
  roles?: Array<BaseFilterListResponseModel>;
  users?: Array<BaseUserResponseModel>;
  capabilities?: Array<BasePermissionCapability>;
  configuration?: Record<string, unknown>;
  parent?: PermissionDataDetailEntity;
  sub?: Array<PermissionDataDetailEntity>;

  removeUnknowValue?(data: PermissionDataDetailEntity) {
    return DataFormat.removeUndefined(
      data as unknown as Record<string, unknown>,
    );
  }
}
